var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('h3',[_vm._v("车辆管理")]),_c('avue-crud',{attrs:{"data":_vm.dataFive,"option":_vm.option,"table-loading":_vm.showLoading},scopedSlots:_vm._u([{key:"menu",fn:function(ref){
var row = ref.row;
return [_c('el-button',{attrs:{"type":"text","size":"mini"},on:{"click":function($event){return _vm.handleDetails(row)}}},[_vm._v("查看详情")])]}}])})],1)}
var staticRenderFns = []

export { render, staticRenderFns }